import { Flex } from 'antd';
import { FilterDefinition } from '../../componentModels/filterDefinition';
import DataFilter from '../../tables/dataFilter';
import { FilterList } from '../list';

type FilterWithSelectedListProps = {
    /**
     * title of the filter dropdown
     */
    label: string;
    /**
     * list of filter options
     */
    filters: FilterDefinition[];
    /**
     * Callback on filter update
     */
    onUpdate: (value: FilterDefinition[]) => void;
};

/**
 * Display filter dropdown and a list of selected options as a tag
 */
export function FilterWithSelectedList({ label, filters, onUpdate }: FilterWithSelectedListProps) {
    return (
        <Flex vertical>
            <DataFilter title={label} filters={filters} updateFilters={onUpdate} />
            <FilterList filters={filters} updateFilterSelector={onUpdate} />
        </Flex>
    );
}
